(function ($) {

    var buildHtml = function (data, filter) {
        filter = $.extend({'visibility': { 'updates': true }}, filter);

        return _(data)
            .filter(filter)
            .sortBy('title')
            .map(function (val) {
                return `
                <li class="${val.passport.subscription_code}">
                    <input data-name="${val.title_label_short}" id="${val.passport.subscription_code}" name="subscriptions[]" value="${val.passport.subscription_code}" type="checkbox" class="tgl tgl-skewed" />
                    <label style="width: ${_lwidth}" data-tg-off="✕" data-tg-on="✔" for="${val.passport.subscription_code}" class="tgl-btn"></label>
                    <strong><img width="15" alt="${val.title_label_short} flag" src="${val.media.flag || ultra_settings.images.default_flag}" style="position:relative; top:2px;"> ${val.title_label_short}</strong>
                </li>`;
            })
            .join('')
    };

    window.loadSubscriptionPage = _.memoize(function (subscriptionsContainer,modalContainer) {
        var subscriptionsContainer = $(subscriptionsContainer);
        var modalContainer = $(modalContainer);

        subscriptionsContainer
        .on('click', 'input', function () {

            if (!!$('#subscriptions.guest').length) {
                modalContainer.fadeIn(300);
                return false;
            } else {

                if ( !! $('#subscriptions.pending').length ) {
                    showResult(_emailverifyupdates, 'info');
                    return false;

                } else {
                    $(this).trigger(this.checked ? 'run-subscribe' : 'run-unsubscribe', [$(this).val()]);
                }

            }
        })
        .on('click', 'li strong', function () {
                // Bind strong to toggle input for better UX
                $(this).siblings('input').trigger('click');
            })
        .on('set-value', 'input', function (event, subscribed) {
                // Event used to set subscribed/unsubscribed value for checkbox
                $(this).prop('checked', !!subscribed);
            })
        .on('run-subscribe', 'input', function (event, code) {
            var el = $(this);
            var text = $(this).data('name');

            showResult(`${_updatessubsrcibe} ${text}`, 'success');
            passport.subscribe(code).always(function () {
                passport.subscriptions().done(function (data) {
                    var found = false;
                    $.each(data, function (index, item) {
                        if (item.code == code) {
                            found = true;
                                //log(_updatessubsrcibe, code);
                                return false;
                            }
                        });
                    el.trigger('set-value', found);
                });
            });
        })
        .on('run-unsubscribe', 'input', function (event, code) {
            var el = $(this);
            var text = $(this).data('name');
            showResult(`${_updatesunsubsrcibe} ${text}`, 'info');
            passport.unsubscribe(code).always(function () {
                passport.subscriptions().done(function (data) {
                    var found = false;
                    $.each(data, function (index, item) {
                        if (item.code == code) {
                            found = true;
                                //log(_updatesunsubsrcibe, code);
                                return false;
                            }
                        });
                    el.trigger('set-value', found);
                });
            });
        });

        $('#subscribe-all').on('click', function () {
            // ALL ON BUTTON
            lis = subscriptionsContainer.find('li');
            li_count = lis.length;
            li_animation_time = 100;
            header_animation_time = li_count * li_animation_time;

            lis.toArray().map(function (e) {
                return function () {
                    return $(e).find('input:not(:checked)').trigger('click').delay(li_animation_time).promise();
                };
            }).reduce(function (cur, next) {
                return cur.then(next);
            }, $().promise());
        });

        $('#unsubscribe-all').on('click', function () {
            // ALL OFF BUTTON
            lis = subscriptionsContainer.find('li');
            li_count = lis.length;
            li_animation_time = 100;
            header_animation_time = li_count * li_animation_time;

            lis.toArray().map(function (e) {
                return function () {
                    return $(e).find('input:checked').trigger('click').delay(li_animation_time).promise();
                };
            }).reduce(function (cur, next) {
                return cur.then(next);
            }, $().promise());
        });

        $(document).on('rebuild-page', function (event, eventsPromise, passportPromise) {

            eventsPromise.done(function (data) {
                subscriptionsContainer.find('.subscribe-list-ultra').html(buildHtml(data, {type_key: 'ultra'}));
                subscriptionsContainer.find('.subscribe-list-beach').html(buildHtml(data, {type_key: 'beach'}));
                subscriptionsContainer.find('.subscribe-list-rtu').html(buildHtml(data, {type_key: 'rtu'}));
                subscriptionsContainer.find('.subscribe-list-resistance').html(buildHtml(data, {type_key: 'resistance'}));
            });

            // Update the subscription page selections
            $.when(eventsPromise, passportPromise).done(function (events, passport) {

                var status = passport[0].status;

                $.each(passport[0].subscriptions, function(index,subscription) {
                    subscriptionsContainer.find(`input[value="${subscription.code}"]`).each(function () {
                        var el = $(this);
                        var code = el.val();
                        el.trigger('set-value', [true]);
                    });
                });

                if (status == 'active') {

                    var countempties = $('#manage-updates input[type="checkbox"]:checked').length;
                    var counttotal = $('#manage-updates input[type="checkbox"]').length;
                    //log(countempties);

                    if (countempties < counttotal ) {
                        //showResult(_moreupdates, 'info');
                    } else {
                        //showResult(_truefan, 'success');
                    }

                    $('#allbtns').removeClass('hide');

                } else {
                    showResult(_emailverifyupdates, 'warning');
                    _subscriptions.addClass('pending');
                }

                var subscribeEvents = getUrlParam('event', true);
                if(subscribeEvents.length) {
                    $.each(subscribeEvents, function(key, subscribeEvent){
                        $('input[value="' + subscribeEvent + '"]:not(:checked)').trigger('click');
                    });
                }
            });

        });

    });

})(jQuery);

function passportGlobalSubscribe() {

    $('.ppgs').each(function(){
        var el = $(this);
        var eventcode = $(this).data('event');
        //var text = $(this).data('text') || 'Get Updates';

        el
        .on('click', function (e) {
            e.preventDefault();
            var el = $(this);
            var _updatesGuest = $('#updates-guest');
            if (!!$('body.upp-pending').length) {
                    //showResult(_updatestextPending, 'warning');
                    _updatesGuest.find('h1').html(_updatestextPending);
                    _updatesGuest.find('p').html(_emailverifyupdates);
                    _updatesGuest.find('div.guest-text .guest-text').hide();
                    _updatesGuest.find('div.guest-text .pending-text').show();
                    _updatesGuest.fadeIn(300);
                    _updatesGuest.find('.btn-resend').on('click', function (e) {
                        e.preventDefault();
                        _updatesGuest.fadeOut(300).promise().then(function () {
                            scrollToTop();
                            sendVerify(upp_page.verify, window.location.href);
                        });
                    });
                }
                else if (!!$('body.upp-guest').length) {
                    //showResult(_updatestext1, 'info');
                    var verifyRedirect = `${upp_page.updates}?${$.param({event: eventcode}, true)}`;
                    $('#signup-form').data('redirect', verifyRedirect);
                    $('#login-form').data('redirect', verifyRedirect);
                    _updatesGuest.find('div.guest-text .guest-text').show();
                    _updatesGuest.find('div.guest-text .pending-text').hide();
                    _updatesGuest.find('h1').html(_updatestext1);
                    _updatesGuest.find('p').html(_agreesignup2);
                    _updatesGuest.fadeIn(300);
                }
                else {
                    el.trigger('run-subscribe', eventcode);
                }
            })
        .on('run-subscribe', function (event, code) {
            var el = $(this);
            el.addClass('registering');

            passport.subscribe(eventcode)
            .done(function (data, textStatus) {
                log('done');
                el.trigger('mark-success');
                showResult(`${_updatessubsrcibe} ${eventcode}`, 'success');
            })
            .fail(function (jqXHR, textStatus, error) {
                log('fail');
                el.trigger('mark-fail', [jqXHR, textStatus, error]);
            });
        })
        .on('mark-success', function (e, code) {
            var $this = $(this);

            return $this
            .html(($this.data('subscribed') || _subscribed) + ' <i class="fas fa-check"></i>')
            .addClass('subscribed')
            .removeClass('get-updates')
            .removeClass('registering');
        })
        .on('mark-fail', function (e, code) {
            var $this = $(this);

            return $this
            .html(_regerror)
            .addClass('error')
            .removeClass('registering')
            .delay(1500)
            .html(_regerror2)
            .delay(3000)
            .html($this.data('subscribe') || _subscribe)
            .removeClass('error')
            .promise().then(function () {
                showResult(sprintf(__('Failed subscribing to %s', 'ultra-2015'), eventcode), 'error');
            });
        });

        $(document).on('logged-in', function (event, passport) {
            var subscription = passport.subscriptions.find(function (value) {
                return value.code == eventcode;
            });
            if (subscription !== undefined) {
                $('a.ppgs').trigger('mark-success');
            }
        });

        $(document).on('logged-out', function (event, passport) {
            $('a.ppgs.subscribed').each(function () {
                var $this = $(this);

                $this
                .removeClass('subscribed')
                .removeClass('registering')
                .addClass('get-updates')
                .html($this.data('subscribe') || _subscribe);
            })

        });

            /*el.wrap('<ul class="ppgs-wrap">');
            el.wrap('<li>');
            el.after('<ul><li class="sub-content"></li></ul>');

            $.get( ultra_settings.endpoints.events_url, function() {})
            .done(function(data) {
                data = sortByTitle(data);
                $.each( data, function( key, val ) {
                    if(val.code == event) {
                        log(val);
                        var location_label = val.passport.location_label || '';
                        var location = val.locations[0] || 'TBD';
                        if(location){
                            if ( location.venue ) {
                                location.city = location.venue + ' &mdash; ' + location.city;
                            }
                            if ( location_label ) {
                                location.city = location_label + ' &mdash; ';
                            } else {
                                if(location.city) {
                                    location.city = location.city + ', ';
                                }
                            }
                            location = location.city + location.country;
                        }

                        //<span class="location">'+location+'</span><br>\
                        var html = '\
                        <article>\
                        <a href="'+val.url+'" target="_blank" class="logo">\
                        <img src="'+val.media.white_logo+'" alt="'+val.title+'" width="180">\
                        </a>\
                        <p class="info">\
                        <span class="date">'+val.date.label+'</span>\</p>\
                        <div class="action">\
                        <a data-updates="'+event+'" class="btn-main btn-lg green-btn quick-subscribe">'+text+' <span class="fas fa-chevron-right"></span></a>\
                        </div>\
                        </article>';
                        //el.html(html);

                        el.parent().find('.sub-content').html(html);
                    }
                });
            });*/
        });
}

function passportGlobalSubscribeFill(passport) {
    //log(passport);
}
